import React from 'react'

function TextInput({
  placeholder,
  value,
  onChange,
  label,
  ariaLabel,
  onKeyPress,
  inputClass,
  labelClass,
  id,
  min,
  max
}) {  
  return (
    <>
        <label id={id} className={`font-semibold text-secondary my-auto ${labelClass}`}>{label}</label>
        <input 
          aria-label={ariaLabel} 
          type="number" 
          min={min}
          max={max}
          value={value} 
          onChange={onChange} 
          onKeyPress={onKeyPress} 
          placeholder={placeholder} 
          className={`bg-light focus:outline-none rounded text-sm leading-none text-secondary py-3 w-full pl-3 mt-2 pr-3 ${inputClass}`} 
        />
    </>
  )
}

export default TextInput
